import { httpPut, httpGet, httpPost, httpDelete } from '../../Util/http';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import update from 'react/lib/update';
import { addEmployeeToWorkplace } from '../Kanban/actions';

export const GET_EMPLOYEE_BOOKINGS_REQUEST = 'GET_EMPLOYEE_BOOKINGS_REQUEST'
export const getEmployeeBookingsRequest = () => {
  return {
    type: GET_EMPLOYEE_BOOKINGS_REQUEST
  }
}

export const GET_EMPLOYEE_BOOKINGS_SUCCESS = 'GET_EMPLOYEE_BOOKINGS_SUCCESS';
export function getEmployeeBookingsSuccess(json){
  return {
    type: GET_EMPLOYEE_BOOKINGS_SUCCESS,
    employees: json.employees
  }
}

export const GET_EMPLOYEE_BOOKINGS_FAILURE = 'GET_EMPLOYEE_BOOKINGS_FAILURE'
export function getEmployeeBookingsFailure() {
  return {
    type: GET_EMPLOYEE_BOOKINGS_FAILURE
  };
}

export const SET_WORKPLACES_FROM_OTHER_DEPARTMENTS = 'SET_WORKPLACES_FROM_OTHER_DEPARTMENTS'
export function setWorkplacesFromOtherDepartments(workplaces) {
  return {
    type: SET_WORKPLACES_FROM_OTHER_DEPARTMENTS,
    workplaces: workplaces
  };
}

export function checkWorkplaces(workplaces) {
  return (dispatch, getState) => {
    let knownWorkplaces = getState().kanbanReducer.workplaces;
    let workplacesToFetch = [];
    workplaces.forEach((workplace) => {
      if(knownWorkplaces[workplace]===undefined)
        workplacesToFetch.push(workplace)
    })
    if(workplacesToFetch.length > 0)
      dispatch(attemptGetWorkplacesFromOtherDepartments(workplacesToFetch))
  };
}

export function attemptGetWorkplacesFromOtherDepartments(workplaceIds) {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/workplaces';
  return dispatch => {
    return httpPost(_url,{workplaceIds: workplaceIds})
    .then(response => {
        return response.json();
    })
    .then(json => {
        dispatch(setWorkplacesFromOtherDepartments(json.workplaces))
    }).catch((e) => {
      dispatch(addAlert(e.message))
    })
  };
}


export function attemptGetEmployeeBookings(departmentId, date) {
  date = JSON.parse(JSON.stringify(date));
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/booking/'+departmentId+'?date=' + date;
  return dispatch => {
    dispatch(getEmployeeBookingsRequest());
    return httpGet(_url)
    .then(response => {
        return response.json();
    })
    .then(json => {
        dispatch(getEmployeeBookingsSuccess(json))
        dispatch(checkWorkplaces(json.workplaces))
    }).catch((e) => {
      dispatch(getEmployeeBookingsFailure())
      dispatch(addAlert(e.message))
    })
  };
}

export const EDIT_BOOKINGS_REQUEST = 'EDIT_BOOKINGS_REQUEST'
export const editBookingsRequest = (bookings, weekdayIndex, employeeIndex) => {
  return {
    type: EDIT_BOOKINGS_REQUEST,
    bookings: bookings,
    weekdayIndex: weekdayIndex,
    employeeIndex: employeeIndex
  }
}

export const EDIT_STICKYNOTE_REQUEST = 'EDIT_STICKYNOTE_REQUEST'
export const editStickynoteRequest = (weekdayIndex, employeeIndex, stickynote, stickynoteIndex) => {
  return {
    type: EDIT_STICKYNOTE_REQUEST,
    weekdayIndex: weekdayIndex,
    employeeIndex: employeeIndex,
    stickynote: stickynote,
    stickynoteIndex: stickynoteIndex
  }
}

export const CREATE_STICKYNOTE_REQUEST = 'CREATE_STICKYNOTE_REQUEST'
export const createStickyNoteRequest = (weekdayIndex, employeeIndex, stickynote) => {
  return {
    type: CREATE_STICKYNOTE_REQUEST,
    stickynote: stickynote,
    weekdayIndex: weekdayIndex,
    employeeIndex: employeeIndex
  }
}

export const CREATE_STICKYNOTE_SUCCESS = 'CREATE_STICKYNOTE_SUCCESS'
export const createStickyNoteSuccess = (weekdayIndex, employeeIndex, id) => {
  return {
    type: CREATE_STICKYNOTE_SUCCESS,
    id: id,
    weekdayIndex: weekdayIndex,
    employeeIndex: employeeIndex
  }
}

export const DELETE_STICKYNOTE_REQUEST = 'DELETE_STICKYNOTE_REQUEST'
export const deleteStickyNoteRequest = (weekdayIndex, employeeIndex, stickynoteIndex) => {
  return {
    type: DELETE_STICKYNOTE_REQUEST,
    weekdayIndex: weekdayIndex,
    employeeIndex: employeeIndex,
    stickynoteIndex: stickynoteIndex
  }
}


export const EDIT_BOOKINGS_SUCCESS = 'EDIT_BOOKINGS_SUCCESS'
export const editBookingsSuccess = () => {
  return {
    type: EDIT_BOOKINGS_SUCCESS
  }
}


export const EDIT_BOOKINGS_FAILURE = 'EDIT_BOOKINGS_FAILURE'
export const editBookingsFailure = (bookings, weekdayIndex, employeeIndex) => {
  return {
    type: EDIT_BOOKINGS_FAILURE,
    bookings: bookings,
    weekdayIndex: weekdayIndex,
    employeeIndex: employeeIndex
  }
}

//method is also used for editting if given an oldBookingIndex as parameter.
//then it will remove and re-add the booking.
export const attemptAddWorkplaceToWeekday = (bookedWorkplace, weekdayIndex, employeeIndex, date, oldBookingIndex) => {

	var _url = process.env.REACT_APP_webApiEndPoint + 'api/booking/book';
	return (dispatch, getState) => {
    //get old bookings for the day
		let bookings = getState().bookEmployeeReducer.employees[employeeIndex].weekdays[weekdayIndex].bookingItems;

    //if its an edit remove the oldbooking first, and RE add it as normal add.
    if(oldBookingIndex || oldBookingIndex===0){
      bookings = update(bookings, {
        $splice: [[oldBookingIndex, 1]]
      })
    }
    //get new bookings for the day
		let newBookings = updateWeekDay(bookings, bookedWorkplace)
    //get the employee
    let employee = getState().bookEmployeeReducer.employees[employeeIndex];

    dispatch(editBookingsRequest(newBookings, weekdayIndex, employeeIndex))

    return httpPut(_url, {weekdayIndex: weekdayIndex, bookings: newBookings, employeeId: employee.id, date: date})
    .then(() => {
      //if the workplace exists in the current kanban, add the employee
      if(getState().kanbanReducer.workplaces[bookedWorkplace.workplaceId])
        dispatch(addEmployeeToWorkplace(employee, bookedWorkplace.workplaceId));
      dispatch(editBookingsSuccess())
    })
    .catch((e) => {
     dispatch(editBookingsFailure(bookings, weekdayIndex, employeeIndex))
     dispatch(addAlert(e.message))
   })
 }
}

// Add sticky note to weekday
export const attemptAddStickyNoteToWeekday = (weekdayIndex, employeeIndex, stickynote, date) => {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/booking/stickynote';
  return (dispatch, getState) => {
    dispatch(createStickyNoteRequest(weekdayIndex, employeeIndex, stickynote))
    let employee = getState().bookEmployeeReducer.employees[employeeIndex];
    return httpPost(_url, {weekdayIndex: weekdayIndex, text: stickynote.text, color: stickynote.color, employeeId: employee.id, date: date})
    .then(response => {
          return response.json();
    })
    .then((newId) => {dispatch(createStickyNoteSuccess(weekdayIndex,employeeIndex, newId))})
    .catch((e) => {
      dispatch(addAlert(e.message))
      dispatch(deleteStickyNoteRequest(weekdayIndex, employeeIndex, stickynote))
   })
 }
}

// Edit stickynote
export const attemptEditStickyNote = (weekdayIndex, employeeIndex, stickynote, stickynoteIndex, date) => {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/booking/stickynote';
  return (dispatch, getState) => {
    dispatch(editStickynoteRequest(weekdayIndex, employeeIndex, stickynote, stickynoteIndex))
    let employee = getState().bookEmployeeReducer.employees[employeeIndex];
    return httpPut(_url, {weekdayIndex: weekdayIndex, text: stickynote.text, color: stickynote.color, employeeId: employee.id, date: date, id: stickynote.id})
    .catch((e) => {
      dispatch(addAlert(e.message))
   })
 }
}

// Delete stickynote
export const attemptDeleteStickyNote = (weekdayIndex, employeeIndex, date, stickynoteIndex, stickynoteId) => {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/booking/stickynote';
  return (dispatch, getState) => {
    let stickynote = getState().bookEmployeeReducer.employees[employeeIndex].weekdays[weekdayIndex].stickyNotes[stickynoteIndex];
    dispatch(deleteStickyNoteRequest(weekdayIndex, employeeIndex, stickynoteIndex));
    let employee = getState().bookEmployeeReducer.employees[employeeIndex];
    return httpDelete(_url, {weekdayIndex: weekdayIndex, employeeId: employee.id, date: date, id: stickynoteId})
    .catch((e) => {
      dispatch(addAlert(e.message))
      dispatch(createStickyNoteRequest(weekdayIndex, employeeIndex, stickynote))
    })
  }
}




//function that takes in a new booking and old bookings and adds it in correct order.
//returns the old bookings with the new one added
function updateWeekDay(bookings, bookedWorkplace){
	let workplaceIndex;
	//find the order of the workplace added
	if(bookings.length!==0){
		bookings.forEach((wp, index) => {
			if(workplaceIndex || workplaceIndex === 0) return;
			if(bookedWorkplace.startTime < wp.startTime){
				workplaceIndex = index;
			}
			if(bookedWorkplace.startTime > wp.startTime){
				if(bookings[index+1]){
					if(bookedWorkplace.startTime > bookings[index+1].startTime){
						return
					}
				}
				workplaceIndex = index+1;
			}
		})
	}
	if(!workplaceIndex) {
		workplaceIndex = 0;
	}

	return update(bookings, {
		$splice: [[workplaceIndex, 0, bookedWorkplace]]
	})
}


export const OPEN_EDIT_BOOKING_MODAL = 'OPEN_EDIT_BOOKING_MODAL'
export const openEditBookingModal = (bookingIndex, weekdayIndex, employeeIndex) => {
  return (dispatch, getState) => {

    let currentBooking = getState().bookEmployeeReducer.employees[employeeIndex].weekdays[weekdayIndex].bookingItems[bookingIndex];

    dispatch({
      type: OPEN_EDIT_BOOKING_MODAL,
      droppedWorkplace: {
        workplaceId: currentBooking.workplaceId,
        weekdayIndex: weekdayIndex,
        employeeIndex: employeeIndex,
        editValues: {
          startTime: currentBooking.startTime,
          endTime: currentBooking.endTime,
          bookingIndex: bookingIndex
        }
      }
    })
  }
}

export const OPEN_EDIT_STICKYNOTE_MODAL = 'OPEN_EDIT_STICKYNOTE_MODAL'
export const openEditStickyNoteModal = (stickynoteIndex, weekdayIndex, employeeIndex) => {
  return (dispatch, getState) => {
    let currentStickyNote = getState().bookEmployeeReducer.employees[employeeIndex].weekdays[weekdayIndex].stickyNotes[stickynoteIndex];
    dispatch({
      type: OPEN_EDIT_STICKYNOTE_MODAL,
      droppedStickynote: {
        weekdayIndex: weekdayIndex,
        employeeIndex: employeeIndex,
        stickyNoteIndex: stickynoteIndex,
        color: currentStickyNote.color,
        id: currentStickyNote.id,
        text: currentStickyNote.text
      }
    })
  }
}


export const ON_WORKPLACE_DROP = 'ON_WORKPLACE_DROP'
export const onWorkplaceDrop = (workplace, weekdayIndex, employeeIndex) => {
  return {
    type: ON_WORKPLACE_DROP,
    droppedWorkplace: {
     workplaceId: workplace.id,
     weekdayIndex: weekdayIndex,
     employeeIndex: employeeIndex
   }
 }
}


export const ON_STICKYNOTE_DROP = 'ON_STICKYNOTE_DROP'
export const onStickynoteDrop = (weekdayIndex, employeeIndex) => {
  return {
    type: ON_STICKYNOTE_DROP,
    droppedStickynote: {
     weekdayIndex: weekdayIndex,
     employeeIndex: employeeIndex
   }
 }
}


export const CANCEL_WORKPLACE_DROP = 'CANCEL_WORKPLACE_DROP'
export const cancelWorkplaceDrop = () => {
    return {
        type: CANCEL_WORKPLACE_DROP
    }
}

export const CANCEL_STICKYNOTE_DROP = 'CANCEL_STICKYNOTE_DROP'
export const cancelStickynoteDrop = () => {
    return {
        type: CANCEL_STICKYNOTE_DROP
    }
}


export const attemptDeleteBooking = (bookedWorkplace, weekdayIndex, employeeIndex, date, oldBookingIndex) => {

  var _url = process.env.REACT_APP_webApiEndPoint + 'api/booking/book';
  return (dispatch, getState) => {
    //get old bookings for the day
    let bookings = getState().bookEmployeeReducer.employees[employeeIndex].weekdays[weekdayIndex].bookingItems;


    //get new bookings for the day
    let newBookings = update(bookings, {
      $splice: [[oldBookingIndex, 1]]
    })
    //get the employee
    let employee = getState().bookEmployeeReducer.employees[employeeIndex];

    dispatch(editBookingsRequest(newBookings, weekdayIndex, employeeIndex))

    return httpPut(_url, {weekdayIndex: weekdayIndex, bookings: newBookings, employeeId: employee.id, date: date})
    .then(() => {
      dispatch(editBookingsSuccess())
    })
    .catch((e) => {
     dispatch(editBookingsFailure(bookings, weekdayIndex, employeeIndex))
     dispatch(addAlert(e.message))
   })
 }
}


export const TOGGLE_IS_COMPRESSED = 'TOGGLE_IS_COMPRESSED'
export const toggleIsCompressed = (bool) => {
    return {
        type: TOGGLE_IS_COMPRESSED,
        bool
    }
}



export const SET_IS_START_OF_WEEK = 'SET_IS_START_OF_WEEK'
export const setIsStartOfWeek = (bool) => {
    return {
        type: SET_IS_START_OF_WEEK,
        bool
    }
}

export const SET_EMPLOYEE_WEEKOVERVIEW_DATE = 'SET_EMPLOYEE_WEEKOVERVIEW_DATE'
export const setEmployeeWeekoverviewDate = (date) => {
    return {
        type: SET_EMPLOYEE_WEEKOVERVIEW_DATE,
        date
    }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/actions.js